"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecksPaidTab = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/ledger/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const app_settings_1 = require("shared/app-settings");
const eob_1 = require("shared/eob");
const store_5 = require("../../store");
require("./eob-checks-paid.less");
const dummyCheck = {
    balance: null,
    checkAmount: null,
    checkDate: null,
    checkNumber: "",
    eobSiteId: null,
    invoiceNumber: "",
    ledgerEntry: null,
    pharmacy: "",
    source: eob_1.EobSource.claim
};
let ChecksPaidTab = class ChecksPaidTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.buttonSaved = true;
        this.showDetail = false;
        this.showAll = false;
        this.loading = false;
        this.eobCheck = dummyCheck;
        this.checksArray = [];
        this.currentUserId = 0; // so IMB users can be recorded in ledger when entering eob details.
        this.confirmChangeDate = false;
        this.dateOptions = [
            {
                id: 0,
                label: "January 1 - January 15",
                value: ["", "01", "15"].join("-")
            },
            {
                id: 1,
                label: "January 16 - January 31",
                value: ["", "01", "31"].join("-")
            },
            {
                id: 2,
                label: "February 1 - February 15",
                value: ["", "02", "15"].join("-")
            },
            {
                id: 3,
                label: "February 16 - February 28",
                value: ["", "02", "28"].join("-")
            },
            {
                id: 4,
                label: "February 16 - February 29",
                value: ["", "02", "29"].join("-")
            },
            {
                id: 5,
                label: "March 1 - March 15",
                value: ["", "03", "15"].join("-")
            },
            {
                id: 6,
                label: "March 16 - March 31",
                value: ["", "03", "31"].join("-")
            },
            {
                id: 7,
                label: "April 1 - April 15",
                value: ["", "04", "15"].join("-")
            },
            {
                id: 8,
                label: "April 16 - April 30",
                value: ["", "04", "30"].join("-")
            },
            {
                id: 9,
                label: "May 1 - May 15",
                value: ["", "05", "15"].join("-")
            },
            {
                id: 10,
                label: "May 16 - May 31",
                value: ["", "05", "31"].join("-")
            },
            {
                id: 11,
                label: "June 1 - June 15",
                value: ["", "06", "15"].join("-")
            },
            {
                id: 12,
                label: "June 16 - June 30",
                value: ["", "06", "30"].join("-")
            },
            {
                id: 13,
                label: "July 1 - July 15",
                value: ["", "07", "15"].join("-")
            },
            {
                id: 14,
                label: "July 16 - July 31",
                value: ["", "07", "31"].join("-")
            },
            {
                id: 15,
                label: "August 1 - August 15",
                value: ["", "08", "15"].join("-")
            },
            {
                id: 16,
                label: "August 16 - August 31",
                value: ["", "08", "31"].join("-")
            },
            {
                id: 17,
                label: "September 1 - September 15",
                value: ["", "09", "15"].join("-")
            },
            {
                id: 18,
                label: "September 16 - September 30",
                value: ["", "09", "30"].join("-")
            },
            {
                id: 19,
                label: "October 1 - October 15",
                value: ["", "10", "15"].join("-")
            },
            {
                id: 20,
                label: "October 16 - October 31",
                value: ["", "10", "31"].join("-")
            },
            {
                id: 21,
                label: "November 1 - November 15",
                value: ["", "11", "15"].join("-")
            },
            {
                id: 22,
                label: "November 16 - November 30",
                value: ["", "11", "30"].join("-")
            },
            {
                id: 23,
                label: "December 1 - December 15",
                value: ["", "12", "15"].join("-")
            },
            {
                id: 24,
                label: "December 16 - December 31",
                value: ["", "12", "31"].join("-")
            }
        ];
        this.loadLedgerBalance = async () => {
            const query = {
                endingDate: this.currentDateRange,
                siteId: this.eobCheck.eobSiteId,
                source: this.eobCheck.source,
                sourcePage: "EOB checks",
                startDate: this.startDate,
                userId: this.currentUserId
            };
            await store_5.eobStore.loadLedgerBalance(query);
            if (store_5.eobStore.loadBalanceFailed)
                return false;
            this.eobCheck.balance = store_5.eobStore.ledgerBalance;
            this.eobCheck.ledgerEntry = store_5.eobStore.ledgerEntryId;
            return true;
        };
        this.updateLedgerFlag = async (siteId, setFlag) => {
            await store_5.eobStore.updateLedgerFlag(siteId, setFlag);
        };
        this.deleteNullLedgerEntry = async (siteId, ledgerId) => {
            await store_2.ledgerStore.deleteNullLedgerEntry(siteId, ledgerId);
        };
        this.runFunc = () => {
            // console.log("inside runfunc");
            // this.checksArray.map((eobCheck: IEobCheck) =>
            //   this.updateLedgerFlag(eobCheck.eobSiteId, 0)
            // );
            // if (eobStore.CheckSubmissionFailed !== "") {
            this.checksArray.map((eobCheck) => {
                this.deleteNullLedgerEntry(eobCheck.eobSiteId, eobCheck.ledgerEntry);
            });
            // }
        };
        this.availableDateOptions = async () => {
            const options = [];
            // const payPeriods = this.payPeriods;
            const currentDate = new Date();
            const month = currentDate.getMonth();
            const year = currentDate.getFullYear();
            const prevyear = String(year - 1);
            const twoYearsAgo = String(year - 2);
            // const nextyear = year + 1; // just for testing if isLeap year test works
            const isLeap = (year) => new Date(year, 1, 29).getDate() === 29;
            let removed;
            // create 3 separate dateOptions arrays that will be spliced individually based on leap year
            const dateOptionsCurrent = this.dateOptions.map(e => e);
            const dateOptionsPrevyear = this.dateOptions.map(e => e);
            const dateOptionsTwoYearsAgo = this.dateOptions.map(e => e);
            if (isLeap(year)) {
                removed = dateOptionsCurrent.splice(3, 1);
            }
            else {
                removed = dateOptionsCurrent.splice(4, 1);
            }
            if (isLeap(Number(prevyear))) {
                removed = dateOptionsPrevyear.splice(3, 1);
            }
            else {
                removed = dateOptionsPrevyear.splice(4, 1);
            }
            if (isLeap(Number(twoYearsAgo))) {
                removed = dateOptionsTwoYearsAgo.splice(3, 1);
            }
            else {
                removed = dateOptionsTwoYearsAgo.splice(4, 1);
            }
            // filter through dateOptions to get specified periods (from dev settings) in available options
            const startRanges = dateOptionsCurrent.map(e => e.label.split(" - ")[0]);
            const curDate = moment().date();
            const lastRange = curDate <= 14 ? 16 : 1;
            const subMonth = curDate <= 14 ? 2 : 1; // to always get period one month ago
            // const subMonth = curDate <= 14 ? 1 : 0; // to always get the previous period
            const endMonth = moment()
                .subtract(subMonth, "month")
                .format("MMMM");
            const lastRangeSearch = `${endMonth} ${lastRange}`;
            console.log("lastRangeSearch", lastRangeSearch);
            const lastRangeIndex = startRanges
                .map((d, i) => {
                if (d.includes(lastRangeSearch)) {
                    return i;
                }
                return null;
            })
                .filter(e => {
                if (e === null) {
                    return false;
                }
                return true;
            })[0];
            console.log("lastRangeIndex", lastRangeIndex);
            let index = lastRangeIndex;
            let indexYear = String(year);
            for (let realX = 1; realX <= this.payPeriods; realX++) {
                const x = realX - 1;
                // do not push this.dateOptions into options. push customized year arrays based on leap year instead
                // options.push(clone(this.dateOptions[index]));
                const currentOptionIndexToAdd = lastRangeIndex - x;
                if (currentOptionIndexToAdd < 0) {
                    if (24 + currentOptionIndexToAdd < 0) {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsTwoYearsAgo[index]));
                            indexYear = twoYearsAgo;
                        }
                        index = 48 + currentOptionIndexToAdd;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = `${options[x].label} (${indexYear})`;
                    }
                    else {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsCurrent[index]));
                            indexYear = String(year);
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        index = 24 + currentOptionIndexToAdd;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = `${options[x].label} (${indexYear})`;
                    }
                }
                else {
                    options.push(ramda_1.clone(dateOptionsCurrent[index]));
                    index = currentOptionIndexToAdd;
                    indexYear = String(year);
                    options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                    options[x].label = `${options[x].label} (${indexYear})`;
                }
            }
            options.shift();
            this.currentDateRange = options[0].value;
            console.log("date options", this.dateOptions);
            console.log("options", options);
            return options;
        };
        this.renderCheckDateRange = () => (React.createElement("div", { className: "check__daterange" },
            React.createElement("div", { className: "edit-check-daterange" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Billing Period:")),
                React.createElement("div", { className: "row" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, moment(this.startDate)
                        .format("MM/DD/YYYY")
                        .concat(" - ", moment(this.currentDateRange).format("MM/DD/YYYY")))),
                React.createElement("br", null))));
        this.renderCheckHeader = () => (React.createElement("div", { className: "check__header" },
            React.createElement("div", { className: "edit-check-header" },
                React.createElement("div", { className: "eob-header-form__headline" },
                    React.createElement(core_1.Typography, { variant: "headline", gutterBottom: true }, "Select a Pharmacy")),
                React.createElement("div", { className: "row" },
                    React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.eobCheck.eobSiteId) || "" }),
                    React.createElement(select_1.MaterialSelect, { options: [
                            { id: 1, label: "Claim", value: eob_1.EobSource.claim },
                            { id: 2, label: "Copay", value: eob_1.EobSource.copay }
                        ], required: true, label: "Financial Source", onSelect: v => {
                            this.eobCheck.source = v;
                            this.handleChangeSite(`${this.eobCheck.eobSiteId}`);
                        }, value: this.eobCheck.source })),
                React.createElement("br", null))));
        this.renderCheckDetail = () => {
            var _a;
            return (React.createElement("div", { className: "check__detail" },
                React.createElement("div", { className: "edit-check-detail" },
                    React.createElement(ui_1.UiForm, { buttons: [
                            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                            "Process Check"
                        ], className: "check-detail-form", onSubmit: this.handleSubmit, loading: this.loading, status: ui_1.FormStatus.Dirty, shouldDisableSave: this.buttonSaved, saved: "Saved", error: this.props.error },
                        this.showDetail && (React.createElement("div", { className: "row" },
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pharmacy", label: "Pharmacy", value: this.eobCheck.pharmacy || "" }),
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "balance", label: "Balance", value: this.eobCheck.balance ? this.eobCheck.balance.toFixed(2) : "" }),
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-date", label: "Check Date *", missing: this.missing.checkDate, value: this.displayDate || "" }),
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-amount", required: true, label: "Check Amount", missing: this.missing.checkAmount, onChange: this.handleChangeString("checkAmount"), value: this.eobCheck.checkAmount || "" }),
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-number", required: true, label: "Check Number", missing: this.missing.checkNum, onChange: this.handleChangeString("checkNumber"), value: this.eobCheck.checkNumber || "" }),
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-number", label: "Invoice Number", numType: "price", missing: this.missing.invoiceNum, onChange: this.handleChangeString("invoiceNumber"), value: (_a = this.eobCheck.invoiceNumber) !== null && _a !== void 0 ? _a : "" }))),
                        this.showAll && this.renderAllChecks()))));
        };
        this.renderCheckDetails = (eobCheck, index) => {
            var _a;
            return (React.createElement("div", { className: "row", key: index },
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pharmacy", label: "Pharmacy", value: eobCheck.pharmacy || "" }),
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "balance", label: "Balance", value: eobCheck.balance ? eobCheck.balance.toFixed(2) : "" }),
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-date", label: "Check Date", missing: this.missing.checkDate, value: this.displayDate || "" }),
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-amount", label: "Check Amount", missing: this.missing.checkAmount, onChange: this.handleChangeArrayString("checkAmount", eobCheck, index), value: eobCheck.checkAmount || "" }),
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-number", label: "Check Number", missing: this.missing.checkNum, onChange: this.handleChangeArrayString("checkNumber", eobCheck, index), value: eobCheck.checkNumber || "" }),
                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "check-number", label: "Payable Invoice Number", missing: this.missing.invoiceNum, onChange: this.handleChangeArrayString("invoiceNumber", eobCheck, index), value: (_a = eobCheck.invoiceNumber) !== null && _a !== void 0 ? _a : "" })));
        };
        this.renderAllChecks = () => this.checksArray.map((eobCheck, index) => this.renderCheckDetails(eobCheck, index));
        this.render = () => (React.createElement(React.Fragment, null,
            this.renderCheckDateRange(),
            React.createElement("br", null),
            this.renderCheckHeader(),
            React.createElement("br", null),
            this.renderCheckDetail(),
            React.createElement("br", null),
            store_5.eobStore.showLoader ? React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "loader" }) : null,
            React.createElement("br", null)));
        this.handleCancel = async () => {
            // if (this.eobCheck !== dummyCheck) {
            //   await eobStore.updateLedgerFlag(this.eobCheck.eobSiteId, 0);
            // }
            await Promise.all(this.checksArray.map((eobCheck) => {
                this.deleteNullLedgerEntry(eobCheck.eobSiteId, eobCheck.ledgerEntry);
            }));
            this.eobCheck = dummyCheck;
            this.checksArray = [];
            this.showDetail = false;
            this.showAll = false;
            this.buttonSaved = true;
        };
        this.handleSubmit = async () => {
            this.loading = true;
            // console.log("this.loading", this.loading);
            this.missing = {
                checkAmount: false,
                checkDate: false,
                checkNum: false,
                invoiceNum: false
            };
            const result = await this.recursiveFunc(this.checksArray, this.currentUserId, this.currentDateRange, this.startDate);
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            if (fieldName === "checkAmount") {
                value = value.replace(/[^0-9\.]/g, "");
                let precision = value
                    .split(".")
                    .slice(1)
                    .join().length;
                if (precision > 2) {
                    precision = 2;
                }
                if (precision > 0) {
                    value = String((Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision));
                }
            }
            this.eobCheck[fieldName] = value;
            this.checksArray[0][fieldName] = value;
            // console.log("value in change string ====>>", this.eobCheck[fieldName]);
            this.buttonSaved = false;
        };
        this.handleChangeArrayString = (fieldName, eobCheck, index) => (event, value) => {
            // if (fieldName === "checkAmount") {
            //   this.checksArray[index][fieldName] = Number(value);
            //   eobCheck.checkAmount = Number(value);
            // }
            // if (fieldName === "checkNumber") {
            //   this.checksArray[index][fieldName] = value;
            //   eobCheck.checkNumber = value;
            // }
            if (fieldName === "checkAmount") {
                value = value.replace(/[^0-9\.]/g, "");
                let precision = value
                    .split(".")
                    .slice(1)
                    .join().length;
                if (precision > 2) {
                    precision = 2;
                }
                if (precision > 0) {
                    value = String((Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision));
                }
            }
            this.checksArray[index][fieldName] = value;
            eobCheck[fieldName] = value;
            // console.log("checksArray all sites on fill out ===>", this.checksArray);
            this.buttonSaved = false;
        };
        this.handleChangeSite = async (id) => {
            this.buttonSaved = true;
            const { value: sites } = store_3.sitesListStore.sites;
            const prevSource = this.eobCheck.source;
            if (id === "0") {
                if (this.checksArray !== []) {
                    await Promise.all(this.checksArray.map((eobCheck) => {
                        this.deleteNullLedgerEntry(eobCheck.eobSiteId, eobCheck.ledgerEntry);
                    }));
                }
                this.showDetail = false;
                this.checksArray = [];
                this.eobCheck = dummyCheck;
                for (const site of store_3.sitesListStore.sites.value) {
                    this.eobCheck.source = prevSource;
                    this.eobCheck.eobSiteId = Number(site.id);
                    this.eobCheck.pharmacy = site.displayName;
                    this.eobCheck.checkDate = moment().format("YYYY-MM-DD HH:mm:ss");
                    this.displayDate = moment().format("MM/DD/YYYY");
                    store_5.eobStore.showLoader = true;
                    const loadresult = await this.loadLedgerBalance();
                    if (!loadresult) {
                        this.checksArray = [];
                        this.eobCheck = dummyCheck;
                        this.showAll = false;
                        break;
                    }
                    console.log("1asdsad");
                    this.checksArray.push(Object.assign({}, this.eobCheck));
                    // console.log("checksArray all sites on select ===>", this.checksArray);
                }
                if (!store_5.eobStore.loadBalanceFailed) {
                    this.eobCheck.eobSiteId = 0;
                    this.showAll = true;
                }
                store_5.eobStore.loadBalanceFailed = false;
            }
            else {
                console.log("2asdsd");
                if (this.checksArray !== []) {
                    await Promise.all(this.checksArray.map((eobCheck) => {
                        this.deleteNullLedgerEntry(eobCheck.eobSiteId, eobCheck.ledgerEntry);
                    }));
                }
                this.showAll = false;
                this.checksArray = [];
                this.eobCheck = dummyCheck;
                const siteFound = sites.find((site) => site.id === Number(id));
                this.eobCheck.eobSiteId = Number(id);
                this.eobCheck.source = prevSource;
                this.activeSite = siteFound;
                this.eobCheck.pharmacy = this.activeSite.displayName;
                this.eobCheck.checkDate = moment().format("YYYY-MM-DD HH:mm:ss");
                this.displayDate = moment().format("MM/DD/YYYY");
                store_5.eobStore.showLoader = true;
                const loadresult = await this.loadLedgerBalance();
                if (!loadresult) {
                    this.checksArray = [];
                    this.eobCheck = dummyCheck;
                    store_5.eobStore.loadBalanceFailed = false;
                    this.showDetail = false;
                }
                else {
                    this.checksArray.push(Object.assign({}, this.eobCheck));
                    this.showDetail = true;
                }
            }
            this.buttonSaved = false;
        };
    }
    componentWillMount() {
        this.missing = {
            checkAmount: false,
            checkDate: false,
            checkNum: false,
            invoiceNum: false
        };
        this.currentUserId =
            store_4.usersStore.user && store_4.usersStore.user.value && store_4.usersStore.user.value.id
                ? store_4.usersStore.user.value.id
                : 0;
        // console.log("current user front end will mount", this.currentUserId);
    }
    async componentDidMount() {
        console.log("current date is in component did mount:", this.currentDateRange);
        console.log("current start date is in component did mount:", this.startDate);
        const payPeriods = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.EobPayPeriods, true);
        this.payPeriods = Number(payPeriods.value);
        // console.log("this.payperiods", this.payPeriods);
        // max pay Periods to load: 48 (2 years)
        if (this.payPeriods > 48) {
            this.payPeriods = 48;
        }
        // console.log("this.payperiods", this.payPeriods);
        this.options = await this.availableDateOptions();
        // create start date
        const enddateArray = this.currentDateRange.split("-");
        const arraytouse = enddateArray.slice(0, -1);
        if (enddateArray[2] === "15") {
            arraytouse.push("01");
        }
        else {
            arraytouse.push("16");
        }
        this.startDate = arraytouse.join("-");
        console.log("current start date is in component did mount:", this.startDate);
        const query = {
            endDate: this.currentDateRange,
            fundType: "paid",
            source: this.eobCheck.source,
            startDate: this.startDate
        };
        store_3.sitesListStore.loadSitesBillingBalance(query);
        window.addEventListener("beforeunload", this.runFunc);
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentWillUnmount() {
        Promise.all(this.checksArray.map((eobCheck) => {
            this.deleteNullLedgerEntry(eobCheck.eobSiteId, eobCheck.ledgerEntry);
        }));
        window.removeEventListener("beforeunload", this.runFunc);
        store_5.eobStore.CheckSubmissionFailed = "";
    }
    async recursiveFunc(checksArray, userId, endDate, startDate) {
        // console.log("inside recursive function");
        const funcDone = await store_5.eobStore.insertChecksLedger(checksArray, userId, endDate, startDate, "paid");
        // console.log("inside recursive function result", funcDone);
        let timer;
        if (!funcDone) {
            timer = setTimeout(() => {
                this.recursiveFunc(checksArray, userId, endDate, startDate);
            }, 1000);
        }
        if (funcDone) {
            // console.log("inside clear timeout");
            clearTimeout(timer);
            if (store_5.eobStore.CheckSubmissionFailed !== "") {
                this.buttonSaved = false;
                setTimeout(() => (this.loading = false), 1000);
                alert("Error in inserting checks.");
            }
            else {
                // this.resetObservables();
                this.buttonSaved = true;
                setTimeout(() => (this.loading = false), 1000);
                setTimeout(() => router_1.RouteManager.transitionTo(`/ledger`), 1000);
            }
        }
        return funcDone;
    }
    get availableOptions() {
        const options = [];
        if (store_3.sitesListStore.sites.value) {
            options.push({ id: 0, label: "All Pharmacies", value: "0" });
            store_3.sitesListStore.sites.value.forEach((site, i) => options.push({
                id: i + 1,
                label: site.displayName || site.name,
                value: site.id.toString()
            }));
        }
        return options;
    }
};
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "buttonSaved", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "showDetail", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "showAll", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "eobCheck", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "checksArray", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "currentUserId", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "activeSite", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "currentDateRange", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "confirmChangeDate", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "tempCurrentDateRange", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "displayDate", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "payPeriods", void 0);
__decorate([
    mobx_1.observable
], ChecksPaidTab.prototype, "options", void 0);
__decorate([
    mobx_1.computed
], ChecksPaidTab.prototype, "availableOptions", null);
__decorate([
    mobx_1.action
], ChecksPaidTab.prototype, "handleChangeSite", void 0);
ChecksPaidTab = __decorate([
    mobx_react_1.observer
], ChecksPaidTab);
exports.ChecksPaidTab = ChecksPaidTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/tabs/eob-checks-paid/eob-checks-paid.tsx
// module id = 3416
// module chunks = 0